export const SLICE_NAME_USER = 'factorRequestsResponses'
export const CREATE_FACTOR_REQUEST_RESPONSE = 'createFactorRequestResponse'
export const GET_FACTOR_REQUEST_RESPONSE = 'getFactorRequestResponse'

export const TAG_FACTOR_REQUEST_RESPONSE = 'FACTOR_REQUEST_RESPONSE'
export default [TAG_FACTOR_REQUEST_RESPONSE]
